export default "__VITE_ASSET__CZzMuZlG__"